// extracted by mini-css-extract-plugin
module.exports = {"card":"PersonSelect_card__1osmI","highlight":"PersonSelect_highlight__3bkn9","card__name":"PersonSelect_card__name__11oIN"};